import { LorenMeteringType } from "../../../../features/loren-assets/interfaces/loren-metering-type";

export enum LorenMetricCategories {
  NUMERIC = "NUMERIC",
  IMAGE = "IMAGE",
  PERCENTAGE = "PERCENTAGE",
  BINARY = "BINARY",
  TRACKING = "TRACKING",
  PRESENCE_BEACON = "PRESENCE_BEACON",
  PRESENCE_SENSOR = "PRESENCE_SENSOR",
}

export const LorenMetricKinds = new Map([
  [LorenMeteringType.BAROMETRIC_PRESSURE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.BATTERY_VOLTAGE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.CO2_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.CURRENT_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.DISTANCE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.DOOR_WINDOW_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.EXTERNAL_CURRENT_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.EXTERNAL_VOLTAGE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.FILL_LEVEL_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.FLUID_FLOW_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.GPS_TRACKER_SENSOR, LorenMetricCategories.TRACKING],
  [LorenMeteringType.HCHO_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.HUMIDITY_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.IMAGE_SENSOR, LorenMetricCategories.IMAGE],
  [LorenMeteringType.ITEM_COUNT_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.IGNITION_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.WATER_LEAK_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.ILLUMINATION_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.LIGHT_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.LIGHT_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.MOVEMENT_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.OZONE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.PIR_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.PM10_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.PM2_5_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.PRESENCE_BEACON, LorenMetricCategories.PRESENCE_BEACON],
  [LorenMeteringType.PRESENCE_SENSOR, LorenMetricCategories.PRESENCE_SENSOR],
  [LorenMeteringType.SMOKE_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.SOIL_TEMPERATURE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.TEMPERATURE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.TILT_BINARY_SENSOR, LorenMetricCategories.BINARY],
  [LorenMeteringType.TVOC_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.VOLTAGE_SENSOR, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.ARCING_SENSOR, LorenMetricCategories.PERCENTAGE],
  [LorenMeteringType.NTL_SENSOR, LorenMetricCategories.PERCENTAGE],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR_VWC, LorenMetricCategories.NUMERIC],
  [LorenMeteringType.ELECTRICAL_CONDUCTIVITY_SENSOR, LorenMetricCategories.NUMERIC],
]);
